/**
*
* AppBackButton
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { withTheme } from 'styled-components';
import { SVGIcon, MaterialIcon } from '@pearsontechnology/aero-components';
import { Link } from 'react-router-dom';
import messages from './messages';
import { SolidBgButton, Wrapper } from './styles';

function getTheme(type, theme) {
  return {
    course: {
      color: theme['color.purpleLight'],
      iconName: 'duotoneCourse',
    },
    lesson: {
      color: theme['color.blueLight'],
      iconName: 'duotoneLesson',
    },
    knowledge: {
      color: theme['color.greenLight'],
      iconName: 'duotoneKnowledge',
    },
    manualGrade: {
      color: theme['color.greenLight'],
      iconName: 'duotoneGrading',
    },
  }[type];
}

function AppBackButton({ intl, type, route, theme }) {
  const buttonTheme = getTheme(type, theme);

  return (
    <Link to={route}>
      <SolidBgButton
        color={buttonTheme.color}
        title={intl.formatMessage(messages.back)}
      >
        <Wrapper>
          <SVGIcon icon={buttonTheme.iconName} viewBox="0 0 24 24" />
        </Wrapper>
        <Wrapper back>
          <MaterialIcon id="home" />
        </Wrapper>
      </SolidBgButton>
    </Link>
  );
}

AppBackButton.propTypes = {
  intl: PropTypes.any,
  type: PropTypes.oneOf(['course', 'lesson', 'knowledge', 'manualGrade']).isRequired,
  route: PropTypes.string,
  theme: PropTypes.object,
};

AppBackButton.defaultProps = {
  route: '/courseware',
};

export default injectIntl(withTheme(AppBackButton));
